// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SkyhopPdfFooter {
  position: relative;
  display: flex;
  flex-direction: column;
  page-break-inside: avoid !important;
}
.SkyhopPdfFooter .SkyhopPdfFooter-Title {
  position: absolute;
  z-index: 10;
  top: 0;
  width: 100%;
  margin: 0;
}
.SkyhopPdfFooter .SkyhopPdfFooter-Title span {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 0.75rem 2.5rem 0.5rem 2.5rem;
  width: fit-content;
  line-height: 1rem;
  background-color: #ff9e16;
  color: black;
  text-transform: uppercase;
  font-weight: 600;
}
.SkyhopPdfFooter .SkyhopPdfFooter-Content {
  position: relative;
  display: flex;
  flex-direction: row;
  gap: var(--pdf-spacing);
  justify-content: center;
  background-color: #40ade2;
  margin: 1rem 0 0 0;
  padding: 3rem var(--pdf-spacing) 2rem var(--pdf-spacing);
  color: white;
  font-weight: 600;
}
.SkyhopPdfFooter .SkyhopPdfFooter-Content .SkyhopPdfFooter-Section {
  list-style: none;
  margin: 0;
  padding: 0;
  align-items: center;
  gap: 3px;
  width: 25%;
}
.SkyhopPdfFooter .SkyhopPdfFooter-Content .SkyhopPdfFooter-Section .SkyhopPdfFooter-Header {
  font-weight: 700;
  text-align: center;
  margin-bottom: 3px;
}
.SkyhopPdfFooter .SkyhopPdfFooter-Content .SkyhopPdfFooter-Section .SkyhopPdfFooter-Item {
  font-weight: 600;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/components/SkyhopPdfFooter/styles.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;AACF;AAAE;EACE,kBAAA;EACA,WAAA;EACA,MAAA;EACA,WAAA;EACA,SAAA;AAEJ;AADI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,qCAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,yBAAA;EACA,gBAAA;AAGN;AAAE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,wDAAA;EACA,YAAA;EACA,gBAAA;AAEJ;AADI;EACE,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,QAAA;EACA,UAAA;AAGN;AAFM;EACE,gBAAA;EACA,kBAAA;EACA,kBAAA;AAIR;AAFM;EACE,gBAAA;EACA,kBAAA;AAIR","sourcesContent":[".SkyhopPdfFooter {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  page-break-inside: avoid !important;\n  .SkyhopPdfFooter-Title {\n    position: absolute;\n    z-index: 10;\n    top: 0;\n    width: 100%;\n    margin: 0;\n    span {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      margin: 0 auto;\n      padding: 0.75rem 2.5rem 0.5rem 2.5rem;\n      width: fit-content;\n      line-height: 1rem;\n      background-color: #ff9e16;\n      color: black;\n      text-transform: uppercase;\n      font-weight: 600;\n    }\n  }\n  .SkyhopPdfFooter-Content {\n    position: relative;\n    display: flex;\n    flex-direction: row;\n    gap: var(--pdf-spacing);\n    justify-content: center;\n    background-color: #40ade2;\n    margin: 1rem 0 0 0;\n    padding: 3rem var(--pdf-spacing) 2rem var(--pdf-spacing);\n    color: white;\n    font-weight: 600;\n    .SkyhopPdfFooter-Section {\n      list-style: none;\n      margin: 0;\n      padding: 0;\n      align-items: center;\n      gap: 3px;\n      width: 25%;\n      .SkyhopPdfFooter-Header {\n        font-weight: 700;\n        text-align: center;\n        margin-bottom: 3px;\n      }\n      .SkyhopPdfFooter-Item {\n        font-weight: 600;\n        text-align: center;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
